import React from "react";
import PropTypes from "prop-types";
import { times } from "lodash";
import { getPropsFromData, RadioField } from "../../FormField";
import FamilyRecord from "./FamilyRecord";

const Family = ({ data }) => {
  return (
    <fieldset>
      <h3>{"FAMILY HISTORY of the EMPLOYEE and DEPENDANT(S) (IF APPLICABLE)"}</h3>
      <table className="hdf-form">
        <thead>
          <tr className="table-title" style={{ textAlign: "left" }}>
            <th colSpan="6">
              Have any of your natural parents or sibling(s) suffered from cancer**, heart disease,
              stroke, high blood pressure, diabetes, mental disorder, tuberculosis or any hereditary
              disease(s)? Please tick:
              <RadioField
                noDivWrapper={true}
                label="Yes"
                radioValue="Yes"
                {...getPropsFromData(data, "EmpFamilyHistory")}
              />
              <RadioField
                noDivWrapper={true}
                label="No"
                radioValue="No"
                {...getPropsFromData(data, "EmpFamilyHistory")}
              />
              <br />
              <strong>
                IF YES, PLEASE PROVIDE DETAILS BELOW (** for Cancer, please specify type of cancer)
              </strong>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr className="align-top">
            <td width="22%">Name of Employee/Dependent</td>
            <td width="13%">
              Relationship
              <br />
              (to Insured)
            </td>
            <td width="25%">Medical Condition (Diagnosis)</td>
            <td width="10%">
              Age at time
              <br />
              of Diagnosis
            </td>
            <td width="10%">
              Age at Death
              <br />
              (If Deceased)
            </td>
            <td width="20%">
              Cause of Death
              <br />
              (If Deceased)
            </td>
          </tr>
          {times(4, n => (
            <FamilyRecord data={data} index={n + 1} key={n} />
          ))}
        </tbody>
      </table>
    </fieldset>
  );
};

Family.propTypes = {
  data: PropTypes.object,
};

export default Family;



// WEBPACK FOOTER //
// ./components/employee/hdf_forms/Aia/AIAHD201906/Family.jsx